document.addEventListener('change', (event) => {
  if (event.target.matches('[data-variant-select]')) {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', event.target.value);
    window.location.assign(url.href);
  }
});
document.addEventListener('input', (event) => {
  if (event.target.matches('[data-cart-quantity]')) {
    const note = document.querySelector('[data-cart-update-note]');
    if (note) note.hidden = false;
  }
});
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    document.querySelectorAll('.nav-dropdown[open]').forEach((menu) => {
      menu.open = false;
      menu.querySelector('summary').focus();
    });
  }
});

// Refresh homepage products from Shopify's full collection in newest-first order.
async function refreshLatestProducts(root = document) {
  const blocks = [...root.querySelectorAll('[data-latest-products]')];
  if (root.matches?.('[data-latest-products]')) blocks.unshift(root);
  await Promise.all(blocks.map(async block => {
    if (block.dataset.loading === 'true') return;
    block.dataset.loading = 'true';
    const url = new URL(block.dataset.collectionUrl, window.location.origin);
    url.searchParams.set('sort_by', 'created-descending');
    url.searchParams.set('section_id', 'latest-products-feed');
    const themePreview = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (themePreview) url.searchParams.set('preview_theme_id', themePreview);
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10000);
    try {
      const response = await fetch(url.href, {credentials:'same-origin', signal:controller.signal});
      if (!response.ok) throw new Error('Product feed unavailable');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const feed = html.querySelector('[data-latest-feed]');
      if (!feed) throw new Error('Missing product feed');
      const products = [...feed.querySelectorAll('.product-card')].slice(0, Number(block.dataset.limit) || 8);
      if (products.length) block.querySelector('[data-latest-grid]').replaceChildren(...products);
      block.querySelector('[data-latest-heading]').textContent = block.dataset.latestTitle;
      block.querySelector('[data-latest-error]').hidden = true;
    } catch (error) {
      block.querySelector('[data-latest-error]').hidden = false;
    } finally {
      clearTimeout(timeout);
      block.dataset.loading = 'false';
    }
  }));
}
refreshLatestProducts();
document.addEventListener('shopify:section:load', event => refreshLatestProducts(event.target));
document.addEventListener('click', event => {
  const button = event.target.closest('[data-video-embed]');
  if (!button) return;
  const frame = document.createElement('iframe');
  frame.src = button.dataset.videoEmbed;
  frame.title = button.dataset.videoTitle || 'Werbevideo';
  frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
  frame.allowFullscreen = true;
  frame.referrerPolicy = 'strict-origin-when-cross-origin';
  button.replaceWith(frame);
});
